import { render, staticRenderFns } from "./PageGallery.vue?vue&type=template&id=2b00baf2&scoped=true"
import script from "./PageGallery.vue?vue&type=script&lang=js"
export * from "./PageGallery.vue?vue&type=script&lang=js"
import style0 from "./PageGallery.vue?vue&type=style&index=0&id=2b00baf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b00baf2",
  null
  
)

export default component.exports